export const useDocumentToCompareStore = (documentId: string) => {
  return useDocumentToCompare(documentId)();
};
